import type { UserInfoUpdateRequestAPI } from '@cobliteam/api-lib/src/account/session/ApiTypes';
import { SessionManager } from '@cobliteam/api-lib/src/account/session/SessionManager';
import type { Session } from '@cobliteam/common-types';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import { Environment } from '@cobliteam/react-environments';
import Alert from '@cobliteam/ui/components/Alert';
import { useMutation } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();
const sessionManager = new SessionManager({ host: env.herbieApiHost });

/**
 * Atualiza os dados do usuário e re-hidrata a sessão com o retorno do backend. Preserva o
 * comportamento e as mensagens do antigo `requestUpdateAccountSaga`.
 */
const useUpdateAccount = () => {
  const setSession = useSessionStore((s) => s.setSession);

  return useMutation<Session, unknown, UserInfoUpdateRequestAPI>({
    mutationFn: (payload) => sessionManager.update(payload),
    onSuccess: (session) => {
      setSession(session);
      Alert.success('Dados alterados com sucesso');
    },
    onError: () => Alert.error('Erro. Tente novamente.'),
  });
};

export default useUpdateAccount;
